import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { ActivePage, ILayoutProps } from '../app-layout/AppLayout';
import { AppLayoutWaitForQueryData } from '../app/AppLayoutWaitForQueryData';
import { pageDefaultContentWidth } from './DetailPage';

export interface IBlankPageProps extends ILayoutProps {
  /**
   * Maximální šířka obsahu stránky, standardně neuvedená - tedy seznamy jsou na celou šířku.
   */
  contentWidth?: number;
  /**
   * Pokud je zapnuto, tak se použije výchozí šířka obsahu stránky obdobně jako má DetailPage, pomocí contentWidth lze nastavit jinou hodnotu.
   */
  defaultContentWidth?: boolean;
  disableScroll?: boolean;
}

export type BlankPageProps = IBlankPageProps;

export const BlankPage: React.FC<BlankPageProps> = ({
  children,
  className,
  queries,
  contentWrapperClassName,
  contentWidth,
  defaultContentWidth,
  currentPage,
  disableScroll,
}) => {
  let cls = classNames(Classes.BLANK_PAGE_LAYOUT, className);
  const contentWrapperCls = classNames(
    Classes.BLANK_PAGE_CONTENT_WRAPPER,
    contentWrapperClassName
  );
  return (
    <div className={cls}>
      <ActivePage currentPage={currentPage} />
      <AppLayoutWaitForQueryData queries={queries ?? []}>
        {() => (
          <div
            className={classNames(Classes.BLANK_PAGE_CONTENT_SC_WRAPPER, {
              [Classes.BLANK_PAGE_CONTENT_SC_WRAPPER_NO]: disableScroll,
            })}
          >
            <div
              className={contentWrapperCls}
              style={{
                maxWidth:
                  contentWidth !== undefined
                    ? contentWidth
                    : defaultContentWidth
                      ? pageDefaultContentWidth
                      : undefined,
              }}
            >
              {typeof children === 'function' ? children() : children}
            </div>
          </div>
        )}
      </AppLayoutWaitForQueryData>
    </div>
  );
};
